import React, { useState, useEffect } from "react";
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { About } from "./components/About";
// import { Gallery } from "./components/Gallery";
import { Contact } from "./components/Contact";
import { TheLab } from "./components/TheLab";
import { ProjectDetail } from "./components/ProjectDetail";
import { ThemeProvider } from "next-themes";
import { AnimatePresence } from "motion/react";
import "./index.css";
import { Toaster } from "./components/ui/sonner";
import type { Project } from "./data/projects";
import { projects } from "./data/projects";

type ViewState = {
  mode: "closed" | "single" | "list";
  project: Project | null;
};

if (typeof window !== "undefined" && "scrollRestoration" in window.history) {
  window.history.scrollRestoration = "manual";
}

export function App() {
  const [viewState, setViewState] = useState<ViewState>({
    mode: "closed",
    project: null,
  });

  React.useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleOpenProject = (id: string) => {
    const project = projects.find((p) => p.id === id) || null;
    if (project) {
      setViewState({ mode: "single", project });
    }
  };

  const handleOpenList = () => {
    setViewState({ mode: "list", project: null });
  };

  const handleClose = () => {
    setViewState({ mode: "closed", project: null });
  };

  return (
    <ThemeProvider attribute="class" defaultTheme="dark" enableSystem={false}>
      <div className="min-h-screen bg-background text-foreground selection:bg-foreground selection:text-background transition-colors duration-300">
        <Navbar />
        <AnimatePresence>
          {viewState.mode !== "closed" && (
            <ProjectDetail
              mode={viewState.mode as "single" | "list"}
              project={viewState.project}
              onClose={handleClose}
            />
          )}
        </AnimatePresence>
        <Hero />
        <About />
        <TheLab onOpenProject={handleOpenProject} onOpenList={handleOpenList} />
        {/* <Gallery /> */}
        <Contact />
        <Toaster />
      </div>
    </ThemeProvider>
  );
}

export default App;
